<template>
  <div class="xband-page">
    <img
      v-for="(item, index) in sections"
      :key="item.file"
      class="section"
      :class="{ 'is-full': item.full }"
      :src="srcOf(item)"
      :srcset="srcsetOf(item)"
      sizes="(max-width: 800px) 100vw, 800px"
      :alt="item.alt"
      :width="item.w"
      :height="item.h"
      :loading="index < 2 ? 'eager' : 'lazy'"
      decoding="async"
    >
  </div>
</template>

<script>
export default {
  name: 'XbandPage',
  data() {
    return {
      publicPath: process.env.BASE_URL,
      // 设计稿分页图，按顺序纵向拼接。
      // 1x 图统一 800px 宽（q80，与页面最大显示宽度一致）
      // x2 标记为 true 的另外提供 1200px / 1600px（q72）供高分屏使用
      // w/h 为 1x 图实际尺寸，用于占位避免懒加载抖动
      sections: [
        {
          file: 'xband-01-intro.jpg',
          alt: 'CODEX XBAND - 24/7 Health Insights, Zero Compromise',
          w: 800,
          h: 818,
          x2: true,
        },
        {
          file: 'xband-02-background.jpg',
          alt: 'XBAND Background',
          w: 800,
          h: 869,
          x2: true,
        },
        {
          file: 'xband-03-golf.jpg',
          alt: 'XBAND on the golf course',
          w: 800,
          h: 1028,
          x2: true,
        },
        {
          file: 'xband-04-product-intro.jpg',
          alt: 'XBAND Product Introduction',
          w: 800,
          h: 1061,
          x2: true,
        },
        {
          file: 'xband-05-features.jpg',
          alt: 'XBAND Smart Detection Module',
          w: 680,
          h: 492,
        },
        {
          file: 'xband-06-features-sleep.jpg',
          alt: 'XBAND Product Features',
          w: 800,
          h: 1006,
          x2: true,
        },
        {
          file: 'xband-07-function-1.jpg',
          alt: 'XBAND Sleep Monitoring',
          w: 680,
          h: 713,
        },
        {
          file: 'xband-08-function-2.jpg',
          alt: 'XBAND Sports and Health Monitoring',
          w: 800,
          h: 787,
          x2: true,
        },
        {
          file: 'xband-09-health-score.jpg',
          alt: 'XBAND Health Score',
          w: 800,
          h: 710,
          x2: true,
        },
        {
          file: 'xband-10-family-sharing.jpg',
          alt: 'XBAND Family Sharing',
          w: 680,
          h: 835,
        },
        {
          file: 'xband-11-color-white.jpg',
          alt: 'XBAND Color Options - Moonlight White',
          w: 800,
          h: 834,
          x2: true,
        },
        {
          file: 'xband-12-color-black.jpg',
          alt: 'XBAND Color Options - Classic Black',
          w: 680,
          h: 709,
        },
        {
          file: 'xband-13-color-orange.jpg',
          alt: 'XBAND Color Options - Vitality Orange',
          w: 680,
          h: 713,
        },
        {
          file: 'xband-14-color-green.jpg',
          alt: 'XBAND Color Options - Forest Green',
          w: 680,
          h: 709,
        },
        {
          file: 'xband-15-product-details.jpg',
          alt: 'XBAND Product Details',
          w: 800,
          h: 1189,
          x2: true,
        },
        {
          file: 'xband-16-purchase-benefits.jpg',
          alt: 'XBAND Purchase Benefits',
          w: 800,
          h: 945,
          x2: true,
        },
        {
          file: 'xband-17-timeline.jpg',
          alt: 'XBAND Timeline',
          w: 800,
          h: 1548,
          x2: true,
        },
        {
          file: 'xband-18-sketches.jpg',
          alt: 'XBAND Sketches',
          w: 800,
          h: 540,
          x2: true,
        },
        {
          file: 'xband-19-construction.jpg',
          alt: 'XBAND Construction',
          w: 800,
          h: 605,
          x2: true,
        },
        {
          file: 'xband-20-factory.jpg',
          alt: 'XBAND Factory',
          w: 679,
          h: 503,
        },
        {
          file: 'xband-21-about-us.jpg',
          alt: 'CODEX About Us',
          w: 800,
          h: 1018,
          x2: true,
        },
      ],
    };
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.$store.commit('toggleLoadingScene', 100);
  },
  mounted() {
    this.$store.commit('toggleLoadingScene', 100);
  },
  methods: {
    srcOf(item) {
      return `${this.publicPath}frontend-assets/img/xband/${item.file}`;
    },
    // 没有高清原图的分页返回 false，Vue 不会渲染 srcset 属性，浏览器直接用 src
    // 三档候选：800（1x）/ 1200（高分屏手机）/ 1600（Retina 桌面）
    srcsetOf(item) {
      if (!item.x2) return false;
      const base = `${this.publicPath}frontend-assets/img/xband`;
      return [
        `${base}/1600/${item.file} 1600w`,
        `${base}/1200/${item.file} 1200w`,
        `${base}/${item.file} 800w`,
      ].join(', ');
    },
  },
};
</script>

<style lang="less" scoped>
.xband-page {
  width: 100%;
  font-size: 0;
  // 让出固定头部的高度，避免首屏图片顶部被 header 遮挡
  // （头部为白色背景，与首屏白底相接，看不出接缝）
  padding-top: 88px;

  @media (max-width: 767px) {
    padding-top: 66px;
  }

  @media (max-width: 575px) {
    padding-top: 50px;
  }

  .section {
    display: block;
    width: 100%;
    // 1x 图为 800px 宽，与页面最大显示宽度一致
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    height: auto;

    // 深色/照片分页保持通栏，避免收窄后两侧出现色差边框
    &.is-full {
      max-width: 100%;
    }
  }
}
</style>
